export default __webpack_public_path__ + "static/media/characterfront.e99436a6.png";